import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PantryIngredientForm from './forms/PantryIngredientForm';

const AddPantryIngredientButton = ({ 
    pantryId, 
    appUserId, 
    onSubmit, 
    onGroceryListUpdate,
    buttonText = "Add Item",
    buttonClassName = "btn add-pantry-ingredient-button",
    buttonStyle = { backgroundColor: '#313638', color: 'white', borderRadius: '24px', fontWeight: '500' },
    buttonHoverStyle = null
}) => {
    const [showFormModal, setShowFormModal] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleFormSubmit = (newIngredient) => {
        if (onSubmit) {
            onSubmit(newIngredient);
        }
        setShowFormModal(false);
    };

    const currentStyle = isHovered && buttonHoverStyle 
        ? { ...buttonStyle, ...buttonHoverStyle }
        : buttonStyle;

    return (
        <>
            <button 
                className={buttonClassName}
                onClick={() => setShowFormModal(true)}
                style={currentStyle}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {buttonText}
            </button>

            {/* Add Item Modal */}
            <Modal show={showFormModal} onHide={() => setShowFormModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add Pantry Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PantryIngredientForm 
                        pantryId={pantryId} 
                        appUserId={appUserId} 
                        onSubmit={handleFormSubmit}
                        onGroceryListUpdate={onGroceryListUpdate}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddPantryIngredientButton;
